import { FC } from "react";
import "./ScheduleTransit.scss";

type ScheduleTransitProps = {
  transitMessage: string;
};

const ScheduleTransit: FC<ScheduleTransitProps> = function (props) {
  const { transitMessage } = props;

  return <div className="schedule-transit">{transitMessage}</div>;
};

export default ScheduleTransit;
